// Angular
// tslint:disable-next-line:whitespace

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
// Models
import { Attachment } from './../../models/attachment';
import { Club, Course, Tee } from './../../models/club';
// External
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { FirebaseApp } from 'angularfire2';
import * as moment from 'moment';
import * as lodash from 'lodash';
import { OAuthService } from './../../services/o-auth';
import { ActivatedRoute } from '@angular/router';

import { ApiService } from './../../services/api';

@Component({
    templateUrl: './add.holes.component.html'
})
export class AddHolesComponent implements OnInit {
    public courseId: string;
    public club: Club;
    public course: Course;
    public clubId: String;

    public courses: Array<Course>;
    public holesFirst: any;
    public holesLast: any;
    public holesCount: number;
    public tee: Tee;
    public teeSize: number;
    constructor(private router: Router, private firebase: FirebaseApp, private apiService: ApiService, private route: ActivatedRoute,
        private fireAuth: AngularFireAuth, private fireDatabase: AngularFireDatabase, private oAuthService: OAuthService) {
        this.tee = {
            name: '',
            color: 'Red',
            $key: 'Red',

        }
    }
    ngOnInit() {

        this.courseId = this.route.snapshot.paramMap.get('id');
        this.clubId = this.route.snapshot.paramMap.get('club');

        this.initData();

    }

    public getType(event) {
        //  console.log(event);

        this.tee.color = event;
        this.tee.$key = event + this.teeSize
    }
    initData() {
        // this.club = this.oAuthService.getClub();

        // console.log(this.club)
        this.teeSize = 0;
        this.apiService.object(`/users/${this.clubId}`)
            .then(club => {
                this.club = club;
                if (this.club.courses) {
                    lodash.forEach(this.club.courses, (item: any, key) => {
                        if (this.courseId === key) {
                            this.holesCount = item.holes;
                            lodash.forEach(item.tees, (tee: any, key1) => {
                                this.teeSize++;
                            });
                            // console.log(this.holesCount)
                            this.holesFirst = [];
                            this.holesLast = [];
                            if (this.holesCount == 9) {
                                for (let i = 0; i < 9; i++) {
                                    this.holesFirst.push({ par: '', yards: '', stroke: '' })
                                }
                            }
                            // console.log(this.holesFirst)
                            if (this.holesCount == 18) {
                                for (let i = 0; i < 9; i++) {
                                    this.holesFirst.push({ par: '', yards: '', stroke: '' })
                                }

                                for (let j = 0; j < 9; j++) {
                                    this.holesLast.push({ par: '', yards: '', stroke: '' })
                                }
                            }
                        }
                    });
                }
            });

    }
    public addTee() {

        if (this.tee.name == undefined || this.tee.name == "") {
            alert('Please enter tee name')
            return
        }

        if (this.holesCount == 9) {
            var l = -1

            for (l = 0; l < this.holesFirst.length; l++) {
                var element = this.holesFirst[l];
                if (element.par == null || element.yards == null || element.stroke == null) {
                    element.isError = true
                    this.holesFirst[l] = element
                    break
                } else {
                    if (element.par == '' || element.yards == '' || element.stroke == '') {
                        element.isError = true
                        this.holesFirst[l] = element
                        break
                    } else {
                        element.isError = false
                        this.holesFirst[l] = element
                    }
                }
            }
            if (l != this.holesFirst.length && l > -1) {
                alert('Please enter all the fields')
            } else {
                this.updateDatabase()
            }
        }
        if (this.holesCount == 18) {
            var k = -1

            for (k = 0; k < this.holesFirst.length; k++) {
                var element = this.holesFirst[k];
                if (element.par == null || element.yards == null || element.stroke == null) {
                    element.isError = true
                    this.holesFirst[k] = element
                    break

                } else {
                    if (element.par == '' || element.yards == '' || element.stroke == '') {
                        element.isError = true
                        this.holesFirst[k] = element
                        break
                    } else {
                        element.isError = false
                        this.holesFirst[k] = element
                    }
                }
            }

            var m = -1

            for (m = 0; m < this.holesLast.length; m++) {
                var element = this.holesLast[m];
                if (element.par == null || element.yards == null || element.stroke == null) {
                    element.isError = true
                    this.holesLast[m] = element
                    break
                } else {
                    if (element.par == '' || element.yards == '' || element.stroke == '') {
                        element.isError = true
                        this.holesLast[m] = element
                        break
                    } else {
                        element.isError = false
                        this.holesLast[m] = element
                    }
                }
            }
            if ((k != this.holesFirst.length && k > -1) || (m != this.holesLast.length && m > -1)) {
                alert('Please enter all the fields')
            } else {
                this.updateDatabase()
            }
        }


    }

    private updateDatabase() {
        const holes = [];

        lodash.forEach(this.holesFirst, (item) => {
            delete item.isError
            holes.push(item)
        })
        lodash.forEach(this.holesLast, (item) => {
            delete item.isError

            holes.push(item)
        })


        const teeKey = String(this.tee.$key).toLowerCase()
        delete this.tee.$key
        this.fireDatabase.database.ref(`/users/${this.club.$key}/courses/${this.courseId}/tees/${teeKey}`)
            .set(this.tee)
            .then(postResult => {
                this.fireDatabase.database.ref(`/courses/${this.club.$key}/${this.courseId}/${teeKey}`)
                    .set(holes)
                    .then(() => {
                        this.router.navigate(['/components/tee', this.courseId, this.clubId]);
                    })
                    .catch(error => {
                        //   console.log(error);
                    });
            })
            .catch(error => {
                // console.log(error);
            });
    }
}



